module.exports = __webpack_public_path__ + "static/media/SnowballNFTRollingPink.cc68bd09.gif";